/*!
 * Calculate the destination point by start point (latitude[numeric], longitude[numeric], bearing (numeric degrees) and distance (km).
 *
 * Optimized from https://stackoverflow.com/a/2637079/6160436
 */
function toRad(val) {
  return val * Math.PI / 180;
}

function toDeg(val) {
  return val * 180 / Math.PI;
}

/**
 * calculate
 * @param {Decimal} latitude - Starting latitude
 * @param {Decimal} longitude - Starting longitude
 * @param {Number}  bearing     - Bearning: From 0=North
 * @param {Number}  distance     - Distance in kilometers
 *
 * @return {Object} Return {lat: Decimal(), lng: Decimal()}
 */

const extendLatlngByDistance = ({
  latitude: startLat = 0,
  longitude: startLng = 0,
  bearing = 0,
  distance = 0
}) => {
  distance = distance / 6371;
  bearing = toRad(bearing);

  startLat = toRad(startLat);
  startLng = toRad(startLng);

  const destLat = Math.asin(
    Math.sin(startLat) * Math.cos(distance) +
      Math.cos(startLat) * Math.sin(distance) * Math.cos(bearing)
  );

  const destLng =
    startLng +
    Math.atan2(
      Math.sin(bearing) * Math.sin(distance) * Math.cos(startLat),
      Math.cos(distance) - Math.sin(startLat) * Math.sin(destLat)
    );

  if (isNaN(destLat) || isNaN(destLng)) return null;

  return {
    lat: toDeg(destLat),
    lng: toDeg(destLng)
  };
};

window.extendLatlngByDistance = extendLatlngByDistance;

export default window.extendLatlngByDistance;
